import { render, staticRenderFns } from "./ListPDPage.vue?vue&type=template&id=21d15ada&"
import script from "./ListPDPage.vue?vue&type=script&lang=js&"
export * from "./ListPDPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPDPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports